import "./PointsTable.css";
// import cancelIcon from "/Xicon.png";
import milions from "../../../../assets/images/5millions.svg";
import ReferPage from "../../../ReferPage/ReferPage";
import useUserInfo from "../../../../Hooks/useUserInfo";
import image from "../../../../assets/ipl/PointsTable.png";
import { useEffect, useRef, useState } from "react";
import { fetchOverallTeamPoints } from "../../../../apis/iplBattle";
import IPLPlayoffsBracket from "../../Iplbattle/iplpayoffs/IPLPlayoffs";

export const PointsTable = (props) => {
    const { userDetails, updateUserInfo,watchScreen } = useUserInfo();
    const [teamPoints, setTeamPoints] = useState([]);
    const [loading, setLoading] = useState(false);
    const scrollableRefPoints = useRef(null);
    const componentMounted = useRef(true);
    const IsTBD = process.env.REACT_APP_IS_TBD_ID;
    // Clean up function to prevent accessing unmounted components
    useEffect(() => {
        return () => {
            componentMounted.current = false;
        };
    }, []);
    
    const CloseFunc = () => {
        props?.setIsPointsTable(false); // Hide the popup
        localStorage.setItem(`IsPointsTable_${props?.userId}`, "false");
    }
    
    const goToThePage = (component, name) => {
        updateUserInfo((prev) => ({
          ...prev,
          currentComponent: component,
          currentComponentText: name,
          lastComponent: userDetails.currentComponent,
          lastComponentText: userDetails.currentComponentText,
          centerCount: userDetails.centerCount + 1,
        }));
    };
    
    const NavigatePage = () => {
        goToThePage(ReferPage, "ReferPage")
    }
    
    useEffect(() => {
        const getTeamPoints = async () => {
            setLoading(true);
            try {
                const data = await fetchOverallTeamPoints(watchScreen?.cricketLeague);
                if (data) {
                    setTeamPoints(data.teams?.filter((el)=>el?.teamId!=IsTBD));
                }
            } catch (error) {
                console.error("Error fetching team points:", error);
            } finally {
                setLoading(false);
            }
        };
        
        getTeamPoints();
    }, []);
    
    // Initial scroll effect to indicate scrollability
    // Remove the current touch event handler useEffect and replace with this:
    
    useEffect(() => {
      
        const handleSafeScroll = () => {
            try {
                if (scrollableRefPoints.current) {
                    const timer1 = setTimeout(() => {
                        if (scrollableRefPoints.current) {
                            scrollableRefPoints.current.scrollLeft = 5;
                            
                            const timer2 = setTimeout(() => {
                                if (scrollableRefPoints.current) {
                                    scrollableRefPoints.current.scrollLeft = 0;
                                }
                            }, 300);
                        }
                    }, 500);
                    
                    return () => clearTimeout(timer1);
                }
            } catch (error) {
                console.error("Error in scroll handler:", error);
            }
        };
        
        handleSafeScroll();
        
        // Add a class to the body when this component is mounted
        // This can be used in CSS to modify global touch behavior
        document.body.classList.add('points-table-active');
        
        // Clean up
        return () => {
            document.body.classList.remove('points-table-active');
        };
    }, []);
    
    // Instead, add a data attribute to the scrollable element
    useEffect(() => {
        // Add a data attribute that can be used to identify this element
        if (scrollableRefPoints.current) {
            scrollableRefPoints.current.setAttribute('data_-scrollable', 'true');
        }
        
        // Clean up
        return () => {
            if (scrollableRefPoints.current) {
                scrollableRefPoints.current.removeAttribute('data_-scrollable');
            }
        };
    }, []);
    
    const teamColors = {
        CHENNAI: "#8A7E00",
        RAJASTHAN: "#720A40",
        KOLKATA: " #1E083E",
        BENGALURU: "#6D0000",
        GUJARAT: "#181E31",
        MUMBAI: "#0D305D",
        HYDERABAD: "#AE6E02",
        PUNJAB: "#7F0F17",
        DELHI: "#134381",
        LUCKNOW: "#0A204D",
    };
    
  return (
    <>
      <div className="spinning-animation-sv"></div>
      <div className="row" style={{ position: "relative", maxWidth: "320px" }}>
        <div className="background-card-sv"></div>

        <IPLPlayoffsBracket CloseFunc={CloseFunc}/>
        {/* <div>
          {loading ? (
            <div className="loaderstyle">
              <div className="spinner"></div>
            </div>
          ) : (
            <div className="grid-table-container points_table" style={{height:"100%"}}>
              <div className="grid-fixed-column">
                <div className="grid-cell header-cell sticky-cell">TEAM</div>
                {teamPoints && teamPoints?.length > 0 ? teamPoints.map((team) => (
                  <div
                    key={`team-logo-${team.teamId}`}
                    className="grid-cell sticky-cell"
                    style={{
                      backgroundColor: teamColors[team.teamName] || "#FFFFFF",
                    }}
                  >
                    <div className="team-logo-wrapper">
                      <img
                        src={team.teamLogo}
                        alt={team.teamName}
                        className="team-logo"
                      />
                    </div>
                    <div></div>
                  </div>
                )) : null}
              </div>
              <div
                className="grid-scrollable-content scrollable-element"
                ref={scrollableRefPoints}
                style={{ 
                  overflowX: "auto", 
                  overflowY: "hidden",
                  WebkitOverflowScrolling: "touch" 
                }}
                data_-scrollable="true"
              >
                <div className="grid-scrollable-header">
                  <div className="grid-cell header-cell">NAME</div>
                  <div className="grid-cell header-cell">NO OF MATCHES</div>
                  <div
                    className="grid-cell header-cell"
                    style={{ paddingRight: "5px" }}
                  >
                    WINS
                  </div>
                  <div
                    className="grid-cell header-cell"
                    style={{ paddingRight: "6px" }}
                  >
                    LOSE
                  </div>
                  <div
                    className="grid-cell header-cell"
                    style={{ paddingLeft: "0px", marginLeft: "0px" }}
                  >
                    NO OF RUNS
                  </div>
                  <div
                    className="grid-cell header-cell"
                    style={{
                      marginLeft: "-3px",
                      backgroundColor: "#4CF038",
                      color: "black",
                      borderRadius: "0px 0px 2px 2px",
                    }}
                  >
                    RANK
                  </div>
                </div>
                <div className="grid-scrollable-body">
                  {teamPoints?.map((team) => (
                    <div
                      className="grid-table-row"
                      key={`team-data-${team.teamId}`}
                    >
                      <div
                        className="grid-cell"
                        style={{
                          backgroundColor: teamColors[team.teamName],
                          fontSize: "10px",
                        }}
                      >
                        {team.teamName}
                      </div>
                      <div
                        className="grid-cell"
                        style={{
                          backgroundColor: teamColors[team.teamName],
                        }}
                      >
                        {team.playedMatches}
                      </div>
                      <div
                        className="grid-cell"
                        style={{
                          backgroundColor: teamColors[team.teamName],
                        }}
                      >
                        {team.winCount}
                      </div>
                      <div
                        className="grid-cell"
                        style={{
                          backgroundColor: teamColors[team.teamName],
                        }}
                      >
                        {team.loseCount}
                      </div>
                      <div
                        className="grid-cell"
                        style={{
                          backgroundColor: teamColors[team.teamName],
                          paddingLeft: "5px",
                          marginLeft: "0px",
                        }}
                      >
                        {team.totalRuns}
                      </div>
                      <div
                        className="grid-cell rank_Font"
                        style={{
                          backgroundColor: teamColors[team.teamName],
                          paddingLeft: "11px",
                        }}
                      >
                        {team.rank}
                      </div>
                    </div>
                  ))}
                </div>
              </div>
            </div>
          )}
        </div> */}
        {/* <img src={image} style={{width:"100%"}}/> */}
        {/* <button
          style={{
            background: "transparent",
            border: "none",
            height: "24px",
          }}
        >
          <img
            onClick={CloseFunc}
            src={"/Xicon.png"}
            className="cancel_button-sv"
          />
        </button> */}
      </div>
    </>
  );
};